// Copyright © 2021 Move Closer
import { __decorate } from "tslib";
import { Component, Prop, Vue } from 'vue-property-decorator';
import { TileSize } from '../Tile.contracts';
/**
 * Tile category component
 * Displays article's parent category name
 */
let TileCategory = class TileCategory extends Vue {
    /**
     * Determines whether category should be shown
     */
    get shouldShow() {
        if (this.size === TileSize.S) {
            return false;
        }
        return !!(this.showCategory && this.hasParent);
    }
    /**
     * Determines whether there's a parent category to be rendered
     */
    get hasParent() {
        return (typeof this.article.parent !== 'undefined' &&
            this.article.parent !== null &&
            typeof this.article.parent.name === 'string' &&
            this.article.parent.name.length > 0);
    }
};
__decorate([
    Prop({
        type: Object,
        required: true
    })
], TileCategory.prototype, "article", void 0);
__decorate([
    Prop({
        type: Boolean,
        required: true
    })
], TileCategory.prototype, "showCategory", void 0);
__decorate([
    Prop({
        type: String,
        required: true
    })
], TileCategory.prototype, "size", void 0);
TileCategory = __decorate([
    Component({
        name: 'TileCategory',
        template: `
    <span v-if="shouldShow" class="tile__category">
      {{ article.parent.name }}
    </span>
  `
    })
], TileCategory);
export { TileCategory };
